import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// TODO: deprecate
export const useCustomerData = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    return state.context.currentCustomer;
  });
};
